module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.is_online) ? _c('div', {
    staticClass: "Offline"
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-centered content"
  }, [_c('h1', [_vm._v("DEAD BALL - Connexion interrompue")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("signal_cellular_connected_no_internet_4_bar")])]), _vm._v(" "), _c('p', [_vm._v("Il semblerait que tu n'ait plus internet, le jeu est en pause pour toi !")]), _vm._v(" "), _c('p', [_vm._v("Relance ta connexion et clique ci-dessous pour relancer le site")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "button is-danger",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("RESTART THE GAME")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db39f3be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppOffline.vue
// module id = 366
// module chunks = 9